export default __webpack_public_path__ + "static/media/check@2x.d61483fe.svg";